import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { avatarColor, initial, solveRate } from '../utils/format';
import './LeaderboardPage.css';

const LeaderboardPage = () => {
  const { user } = useAuth();
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get('/api/users/leaderboard');
      setLeaderboard(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError('Failed to load leaderboard data. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  let body;
  if (loading) {
    body = <p className="lb-note">Loading leaderboard...</p>;
  } else if (error) {
    body = (
      <div className="lb-note lb-error">
        <p>{error}</p>
        <button type="button" className="cr-btn sm" onClick={load}>Try Again</button>
      </div>
    );
  } else if (leaderboard.length === 0) {
    body = <p className="lb-note">No players found</p>;
  } else {
    body = (
      <div role="table" aria-label="Leaderboard">
        <div className="cr-tr cr-th" role="row">
          <span role="columnheader">Rank</span>
          <span role="columnheader">Player</span>
          <span role="columnheader" className="cr-r">Rating</span>
          <span role="columnheader" className="cr-r">Games</span>
          <span role="columnheader" className="cr-r">Solve Rate</span>
        </div>
        {leaderboard.map((player, index) => {
          const me = user && (player._id === user._id || player.username === user.username);
          return (
            <div key={player._id || player.username} className={`cr-tr${me ? ' cr-me' : ''}`} role="row">
              <span className="cr-tnum lb-rank" role="cell">{index + 1}</span>
              <span role="cell" className="lb-player-cell">
                <Link to={`/profile/${player.username}`} className="cr-player lb-player">
                  <span className="cr-av" style={{ background: avatarColor(player.username) }}>{initial(player.username)}</span>
                  <b>{player.username}</b>
                </Link>
              </span>
              <span className="cr-r cr-tnum lb-rating" role="cell">{player.rating}</span>
              <span className="cr-r cr-tnum cr-muted" role="cell">{player.gamesPlayed}</span>
              <span className="cr-r cr-tnum cr-muted" role="cell">{solveRate(player.wins, player.gamesPlayed)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="cr-page lb-page">
      <h1 className="cr-title">Leaderboard</h1>
      <section className="cr-card lb">{body}</section>
    </div>
  );
};

export default LeaderboardPage;
